const regStudentTardinessLogLocation = {
  Unset: 0,
  InitialPEI: 1,
  EligibilityDetermination: 2,
  InitialEvaluation: 3,
};

export default regStudentTardinessLogLocation;
